/* eslint-disable consistent-return */
import eventQueue from '../queue';
import { EventAction } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var data = _a.data, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (data.eventId === 'MSE-skip') {
            return fireAnalyticsEvent(EventAction.TAP_SKIP, {});
        }
    });
}
attachEventListeners();
